import { createSlice } from '@reduxjs/toolkit'

interface SystemState {
  config: any
  loading: boolean
  error: string | null
}

const initialState: SystemState = {
  config: {},
  loading: false,
  error: null,
}

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
})

export const { clearError } = systemSlice.actions
export default systemSlice.reducer